import { render, staticRenderFns } from "./HomeSearch.vue?vue&type=template&id=5262e449&"
import script from "./HomeSearch.vue?vue&type=script&lang=ts&"
export * from "./HomeSearch.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/did-homepage/did-homepage/src/components/Button.vue').default})
